import { axios } from '@/lib/axios';

export const deleteSelectedNotifications = (id: string) => {
  const payload = {
    id: id,
  };
  return axios.post('/customer-api/delete-notifications', payload);
};
